export default "__VITE_ASSET__Deo0Qxbe__"